/*load more*/
jQuery( function ( $ ) {
	$( '#true_loadmore' ).click( function () {
		$( this ).text( 'Загрузка...' ); // изменяем текст кнопки, вы также можете добавить прелоадер
		var data = {
			'action': 'loadmore',
			'query': true_posts,
			'page': current_page
		};
		$.ajax( {
			url: ajaxurl, // обработчик
			data: data, // данные
			type: 'POST', // тип запроса
			success: function ( data ) {
				if ( data ) {
					$( '#true_loadmore' ).text( 'Загрузить еще' ); // вставляем новые посты
					$( '.obj_row' ).before( data ); // вставляем новые посты
					current_page ++; // увеличиваем номер страницы на единицу
					if ( current_page == max_pages ) {
						$( "#true_loadmore" ).remove();
					} // если последняя страница, удаляем кнопку
				} else {
					$( '#true_loadmore' ).remove(); // если мы дошли до последней страницы постов, скроем кнопку
				}
			},
			/*ЕСЛИ ЕСТЬ load more для картинок*/
			complete: function () {
				var myLazyLoad = new LazyLoad( {
					elements_selector: ".lazy-load"
				} );
				/*btnHover();*/
			}
		} );
	} );
} );